module.exports = __webpack_public_path__ + "img/pr-2.8a154bc8.png";